import React, { useContext, useState } from "react";
import trans, { formatDateTime, isRTL } from "../../../utils";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import { popupcontext } from "../../../context/Popupscontext";
import { TextAreaInput } from "../../Helpers/Input/Input";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useResubmitSubmittalMutation } from "../../../Redux/service/Submittals/Submittals";
import Button from "../../Helpers/Button/Button";
import * as Yup from "yup";
import { Timeline } from "antd";
import {
	DownloadOutlined,
	FileTextOutlined,
	ClockCircleOutlined,
	CheckCircleOutlined,
	CloseCircleOutlined,
	ToolOutlined,
	UserOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
export default function SubmittalsHistoryWork({
	history,
	setActiveOption,
	setResubmit,
	refetch,
	resubmit,
}) {
	const bgColor = (severity) => {
		if (severity === "RETURNED_TO_CONTRACTOR") {
			return "#f6ffed";
		} else if (severity === "REVISION_REQUIRED") {
			return "#fff1f0";
		} else {
			return "#e6f4ff";
		}
	};
	const borderColor = (severity) => {
		if (severity === "RETURNED_TO_CONTRACTOR") {
			return "#b7eb8f";
		} else if (severity === "REVISION_REQUIRED") {
			return "#ffa39e";
		} else {
			return "#91caff";
		}
	};
	let { setcurrentSubmittalId, currentSubmittalId, setReloadData } =
		useContext(popupcontext);

	const getActionIcon = (action) => {
		const iconStyle = (color) => ({
			color,
			backgroundColor: `${color}20`, // lighter version (20 = ~12% opacity)
			borderRadius: "50%",
			padding: "6px",
			fontSize: "16px",
		});
		switch (action) {
			case "RETURNED_TO_CONTRACTOR":
				return <ToolOutlined style={iconStyle("#b1b1b1ff")} />;
			case "PENDING_CONSULTANT":
				return <ToolOutlined style={iconStyle("#d46b08")} />;
			case "PENDING_QA":
				return <ToolOutlined style={iconStyle("#d46b08")} />;
			case "REJECTED":
				return <CloseCircleOutlined style={iconStyle("#cf1322")} />;
			case "REVISION_REQUIRED":
				return <CloseCircleOutlined style={iconStyle("#722ed1")} />;
			case "APPROVED":
				return <CheckCircleOutlined style={iconStyle("#52c41a")} />;
			default:
				return <ClockCircleOutlined style={iconStyle("#1890ff")} />;
		}
	};
	const getActionColor = (action) => {
		switch (action) {
			case "PENDING_CONSULTANT":
			case "PENDING_QA":
				return "orange";
			case "REVISION_REQUIRED":
				return "purple";
			case "REJECTED":
				return "red";
			case "APPROVED":
				return "green";
			case "RETURNED_TO_CONTRACTOR":
				return "gray";
			default:
				return "blue";
		}
	};
	const inf = useSelector((state) => state.users.user);
	return (
		<>
			{history.length > 0 ? (
				<Timeline
					items={history.map((item, index) => ({
						key: item.id || index,
						dot: getActionIcon(item?.toStatus),
						color: getActionColor(item?.toStatus),
						children: (
							<div className="d-flex flex-column gap-1">
								<div className="fs-6 fw-600">{trans(item.toStatus)}</div>
								<div className="text-secondary fs-6">
									{formatDateTime(item.changedAt)}
								</div>
								{item.comments && (
									<div className="fs-6 mt-1" style={{ color: "#595959" }}>
										{item.comments}
									</div>
								)}
								{item.changedBy && (
									<div className="d-flex align-items-center gap-2 mt-1">
										<span className="text-muted fs-6">
											{trans("By")}:{" "}
											{item.changedBy.name || item.changedBy.email}
										</span>
									</div>
								)}
							</div>
						),
					}))}
				/>
			) : (
				<div className="text-center text-muted py-4">
					{trans("No history available")}
				</div>
			)}
		</>
	);
}
